// taken from:

import { Builder } from "flatbuffers";
import {
  PlayEventTypeWire,
  TrackedEventWire,
  TrackedEventWireT
} from "../../flatbuffers/mannequin";

// https://github.mlbam.net/baseball-data/binapi-statcast/blob/master/src/main/java/net/mlbam/statcast/enums/PlayEventType.java
export enum PlayEventType {
  BEGIN_OF_PLAY = 0,
  PITCHER_FIRST_MOVEMENT = 1,

  BALL_WAS_PITCHED = 2,
  BALL_WAS_HIT = 3,
  BALL_WAS_CAUGHT = 4,
  BALL_WAS_CAUGHT_OUT = 5,
  BALL_WAS_RELEASED = 6,
  BALL_WAS_DEFLECTED = 7,

  TAG_WAS_APPLIED = 8,
  PICK_OFF_BALL_RELEASED = 9,
  END_OF_PLAY = 10,
  REMOVED = 11,

  // assume these are not used:
  TRACKMAN_BALL_WAS_RELEASED = 12,
  TRACKMAN_BALL_WAS_DEFLECTED = 13,
  TRACKMAN_BALL_WAS_CATCHER_RELEASED = 14,
  TRACKMAN_PICK_OFF_BALL_RELEASED = 15,
  TRACKMAN_BALL_BOUNCE = 16,

  BALL_WAS_FIELDED = 17,
  UNKNOWN = 18,
  BALL_BOUNCE = 19,

  OPERATOR_INPUT_NOT_FOUND = 22,
  OFF_THE_WALL = 23,
}

export const playEventTypeMap: {
  [key in PlayEventType]: string;
} = {
  [PlayEventType.BEGIN_OF_PLAY]: "BEGIN_OF_PLAY",
  [PlayEventType.PITCHER_FIRST_MOVEMENT]: "PITCHER_FIRST_MOVEMENT",
  [PlayEventType.BALL_WAS_PITCHED]: "BALL_WAS_PITCHED",
  [PlayEventType.BALL_WAS_HIT]: "BALL_WAS_HIT",
  [PlayEventType.BALL_WAS_CAUGHT]: "BALL_WAS_CAUGHT",
  [PlayEventType.BALL_WAS_CAUGHT_OUT]: "BALL_WAS_CAUGHT_OUT",
  [PlayEventType.BALL_WAS_RELEASED]: "BALL_WAS_RELEASED",
  [PlayEventType.BALL_WAS_DEFLECTED]: "BALL_WAS_DEFLECTED",
  [PlayEventType.TAG_WAS_APPLIED]: "TAG_WAS_APPLIED",
  [PlayEventType.PICK_OFF_BALL_RELEASED]: "PICK_OFF_BALL_RELEASED",
  [PlayEventType.END_OF_PLAY]: "END_OF_PLAY",
  [PlayEventType.REMOVED]: "REMOVED",
  [PlayEventType.TRACKMAN_BALL_WAS_RELEASED]: "TRACKMAN_BALL_WAS_RELEASED",
  [PlayEventType.TRACKMAN_BALL_WAS_DEFLECTED]: "TRACKMAN_BALL_WAS_DEFLECTED",
  [PlayEventType.TRACKMAN_BALL_WAS_CATCHER_RELEASED]:
    "TRACKMAN_BALL_WAS_CATCHER_RELEASED",
  [PlayEventType.TRACKMAN_PICK_OFF_BALL_RELEASED]:
    "TRACKMAN_PICK_OFF_BALL_RELEASED",
  [PlayEventType.TRACKMAN_BALL_BOUNCE]: "TRACKMAN_BALL_BOUNCE",
  [PlayEventType.BALL_WAS_FIELDED]: "BALL_WAS_FIELDED",
  [PlayEventType.UNKNOWN]: "UNKNOWN",
  [PlayEventType.BALL_BOUNCE]: "BALL_BOUNCE",
  [PlayEventType.OPERATOR_INPUT_NOT_FOUND]: "OPERATOR_INPUT_NOT_FOUND",
  [PlayEventType.OFF_THE_WALL]: "OFF_THE_WALL",
};

export interface TrackedEvent {
  timestamp: string;
  batSide: string;
  pitchHand: string;
  atBatNumber: number;
  pitchNumber: number;
  pickoffNumber: number;
  szTop: number;
  szBot: number;
  eventType: string;
  x: number;
  y: number;
  z: number;
  position: number;
  eventTypeId: PlayEventType;
}

export class TrackedEventSerializer {
  static serializeBinary(trackedEvent: TrackedEvent, builder: Builder): number | undefined {
    const trackedEventObj = new TrackedEventWireT(
      trackedEvent.timestamp,
      trackedEvent.batSide,
      trackedEvent.pitchHand,
      trackedEvent.atBatNumber,
      trackedEvent.pitchNumber,
      trackedEvent.pickoffNumber,
      trackedEvent.szTop,
      trackedEvent.szBot,
      trackedEvent.eventType,
      trackedEvent.x,
      trackedEvent.y,
      trackedEvent.z,
      trackedEvent.position,
      trackedEvent.eventTypeId as unknown as PlayEventTypeWire,
    );

    return trackedEventObj.pack(builder);
  }

  static deserializeBinary(eventWire?: TrackedEventWire): TrackedEvent | undefined {
    if (!eventWire) return undefined;
    const unpacked = eventWire.unpack();

    const timestamp = unpacked.timestamp?.toString();
    const batSide = unpacked.batSide?.toString();
    const pitchHand = unpacked.pitchHand?.toString();
    const atBatNumber = unpacked.atBatNumber;
    const pitchNumber = unpacked.pitchNumber;
    const pickoffNumber = unpacked.pickoffNumber;
    const szTop = unpacked.szTop;
    const szBot = unpacked.szBot;
    const eventType = unpacked.eventType?.toString();
    const x = unpacked.x;
    const y = unpacked.y;
    const z = unpacked.z;
    const position = unpacked.position;
    const eventTypeId = unpacked.eventTypeId as unknown as PlayEventType;

    if (
      timestamp === undefined ||
      batSide === undefined ||
      pitchHand === undefined ||
      eventType === undefined
    ) {
      console.error("invalid trackedEvent");
      return undefined;
    }

    return {
      timestamp,
      batSide,
      pitchHand,
      atBatNumber,
      pitchNumber,
      pickoffNumber,
      szTop,
      szBot,
      eventType,
      x,
      y,
      z,
      position,
      eventTypeId,
    };
  }
}
